export default "/_next/static/chunks/fonts/Rubik-Medium-4ddab52b8ff256c808344c15164118c6.ttf";